export default __webpack_public_path__ + "static/media/transactions-screen.dd259313.png";